import { hasProperty, isObject } from './type.utils';
import { ApiError, type ApiErrorData, type ErrorCode, ErrorCodes } from './types/error.types';

export const isApiError = (error: unknown): error is ApiError => {
    return error instanceof ApiError;
};

export const isApiErrorData = (value: unknown): value is ApiErrorData => {
    return value !== undefined && isObject(value) && 'errorCode' in value;
};

export const isNotFoundError = (error: unknown) => isApiError(error) && error.status === 404;

export const isApiErrorCode = (value: unknown): value is ErrorCode => {
    return value !== undefined && typeof value === 'string' && hasProperty(ErrorCodes, value);
};
